import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */
/* eslint-disable @atlaskit/design-system/prefer-primitives */
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */

import React from 'react';
import styled from '@emotion/styled';
import { HEADER_HEIGHT, SECONDARY_NAV_WIDTH } from '../../common/constants';
export var SecondaryNav = function SecondaryNav() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Background, null), /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Image, null)));
};
var Background = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-block;\n  position: fixed;\n  top: ", "px;\n  left: 0;\n  height: 100%;\n  width: ", "px;\n  background: #2c333a;\n  border-right: 1px solid #454f59;\n"])), HEADER_HEIGHT, SECONDARY_NAV_WIDTH);
var Wrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: fixed;\n  top: ", "px;\n  left: 0;\n  width: ", "px;\n"])), HEADER_HEIGHT, SECONDARY_NAV_WIDTH);
var Image = function Image() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "240",
    height: "1100",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "240",
    height: "1100",
    fill: "#2C333A"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_782_7656)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    transform: "translate(26 88)",
    fill: "white",
    fillOpacity: "0.01"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "22",
    y: "84",
    width: "32",
    height: "32",
    rx: "3",
    fill: "#454F59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "66",
    y: "97",
    width: "71",
    height: "6",
    rx: "3",
    fill: "#454F59"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    transform: "translate(26 132)",
    fill: "white",
    fillOpacity: "0.01"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "22",
    y: "128",
    width: "32",
    height: "32",
    rx: "3",
    fill: "#454F59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "66",
    y: "141",
    width: "71",
    height: "6",
    rx: "3",
    fill: "#454F59"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    transform: "translate(26 176)",
    fill: "white",
    fillOpacity: "0.01"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "22",
    y: "172",
    width: "32",
    height: "32",
    rx: "3",
    fill: "#454F59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "66",
    y: "185",
    width: "71",
    height: "6",
    rx: "3",
    fill: "#454F59"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    transform: "translate(26 220)",
    fill: "white",
    fillOpacity: "0.01"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "22",
    y: "216",
    width: "32",
    height: "32",
    rx: "3",
    fill: "#454F59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "66",
    y: "229",
    width: "71",
    height: "6",
    rx: "3",
    fill: "#454F59"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    transform: "translate(26 290)",
    fill: "white",
    fillOpacity: "0.01"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "22",
    y: "286",
    width: "32",
    height: "32",
    rx: "3",
    fill: "#454F59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "66",
    y: "299",
    width: "71",
    height: "6",
    rx: "3",
    fill: "#454F59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "16",
    y: "326",
    width: "208",
    height: "40",
    rx: "3",
    fill: "#454F59"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    transform: "translate(40 334)",
    fill: "white",
    fillOpacity: "0.01"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "52",
    cy: "346",
    r: "2",
    fill: "#596773"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "72",
    y: "343",
    width: "125",
    height: "6",
    rx: "3",
    fill: "#596773"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    transform: "translate(40 378)",
    fill: "white",
    fillOpacity: "0.01"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "52",
    cy: "390",
    r: "2",
    fill: "#454F59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "72",
    y: "387",
    width: "125",
    height: "6",
    rx: "3",
    fill: "#454F59"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    transform: "translate(40 422)",
    fill: "white",
    fillOpacity: "0.01"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "52",
    cy: "434",
    r: "2",
    fill: "#454F59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "72",
    y: "431",
    width: "125",
    height: "6",
    rx: "3",
    fill: "#454F59"
  })), /*#__PURE__*/React.createElement("rect", {
    x: "18",
    y: "24",
    width: "40",
    height: "40",
    rx: "3",
    fill: "#092957"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "66",
    y: "29",
    width: "97",
    height: "12",
    rx: "3",
    fill: "#454F59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "66",
    y: "53",
    width: "141",
    height: "6",
    rx: "3",
    fill: "#454F59"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_782_7656"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "208",
    height: "374",
    fill: "white",
    transform: "translate(16 80)"
  }))));
};